import React, { useEffect, useState } from 'react'
import { Button, useMediaQuery, Box, Snackbar, Alert } from '@mui/material'
import { MuiTelInput } from 'mui-tel-input'
import { digitalAppApi } from '../../../store/services/digitalAppApi'
import AuthTextField from '../../Rcomp/AuthTextField/AuthTextField'
import CustomSelect from '../../Rcomp/AuthSelect/AuthSelect'

const Registration = ({ phone }) => {
  const mobileView = useMediaQuery('(max-width: 798px)')
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' })

  const [register] = digitalAppApi.useRegisterAdminMutation()

  const [formData, setFormData] = useState({
    name: '',
    username: '',
    userType: '',
    phoneNumber: phone || '',
    password: '',
    repeatPassword: '',
    code: '',
    adminPass: '',
  })

  const handleChange = (event) => {
    const { name, value } = event.target
    setFormData({ ...formData, [name]: value })
  }

  const handlePhoneChange = (value) => {
    setFormData({ ...formData, phoneNumber: value })
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    try {
      await register({ data: formData }).unwrap()
      setSnackbar({ open: true, message: 'Registration success. Please login', severity: 'success' })
      setTimeout(() => window.location.reload(), 1500)
    } catch (e) {
      const msg = typeof e?.data === 'string' ? e.data : e?.data?.message || e?.message || 'Registration failed'
      setSnackbar({ open: true, message: msg, severity: 'error' })
    }
  }

  const handleCloseSnackbar = () => setSnackbar((s) => ({ ...s, open: false }))

  useEffect(() => {
    setFormData({ ...formData, phoneNumber: phone })
  }, [phone])

  return (
    <>
      <form
        onSubmit={handleSubmit}
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          maxHeight: '90vh',
          backgroundColor: '#f5f5f5',
          padding: mobileView ? '24px 20px' : '32px 50px',
          overflow: 'auto',
          borderRadius: '20px',
          gap: '2px',
          maxWidth: 420,
          width: '100%',
        }}
      >
        <h2 style={{ textAlign: 'center', color: '#5FC56E', fontFamily: 'Montserrat', margin: '0 0 8px 0' }}>
          WELCOME to TPO<span style={{ color: '#186419' }}>Admin</span>
        </h2>
        <h3 style={{ textAlign: 'center', color: '#186419', fontFamily: 'Montserrat', margin: '0 0 20px 0', fontSize: '1.1rem' }}>Sign Up</h3>
        <Box sx={{ width: '100%', maxWidth: 320 }}>
          <AuthTextField label='Name' name='name' value={formData.name} onChange={handleChange} />
        </Box>
        <Box sx={{ width: '100%', maxWidth: 320, mt: 1.5 }}>
          <CustomSelect name='userType' value={formData.userType} label='User Type' onChange={handleChange} />
        </Box>
        <Box sx={{ width: '100%', maxWidth: 320, mt: 1.5 }}>
          <AuthTextField label='Code' name='code' value={formData.code} onChange={handleChange} />
        </Box>
      {/* <TextField required label='Code' variant='outlined' name='code' value={formData.code} onChange={handleChange} fullWidth margin='normal' /> */}

        {formData.userType === 'admin' && (
          <Box sx={{ width: '100%', maxWidth: 320, mt: 1.5 }}>
            <AuthTextField label='Admin Code' name='adminPass' value={formData.adminPass} onChange={handleChange} />
          </Box>
        )}
        {/* <TextField
        //   required
        //   label='Admin Code'
        //   variant='outlined'
        //   name='adminPass'
        //   value={formData.adminPass}
        //   onChange={handleChange}
        //   fullWidth
        //   margin='normal'
        // /> */}

        <Box sx={{ width: '100%', maxWidth: 320, mt: 1.5 }}>
          <MuiTelInput
        required
        MenuProps={{ PaperProps: { style: { maxHeight: '200px', width: '300px' } } }}
        InputProps={{
          disableUnderline: true,
          sx: {
            border: 'none',
          },
        }}
        variant='standard'
        sx={{
          width: mobileView ? '90%' : '80%',
          margin: '15px',

          '& .MuiTelInput-TextField': {
            border: 'none',
          },
          '& .MuiTelInput-IconButton': {
            border: '1px solid #186419',
            width: 50,
            height: 40,
            borderRadius: '20px 0px 0px 20px',

            '&:hover': {
              backgroundColor: '#186419',
              color: 'white',
            },
          },
          '& .MuiInputBase-input': {
            paddingTop: 1,
            paddingBottom: 1,
            paddingLeft: 1,
            // paddingRight: 10,
            borderTop: '1px solid #186419',
            borderBottom: '1px solid #186419',
            borderRight: '1px solid #186419',
            borderLeft: '1px solid #186419',

            borderTopRightRadius: '20px',
            borderBottomRightRadius: '20px',
            // borderLeft: '1px solid #186419',
          },
          '& .MuiInputBase-root': {
            border: 'none',
          },
        }}
            value={formData.phoneNumber}
            onChange={(value) => setFormData({ ...formData, phoneNumber: value })}
          />
        </Box>
      {/* <TextField
        label='Email'
        type='email'
        variant='outlined'
        name='email'
        value={formData.email}
        onChange={handleChange}
        fullWidth
        margin='normal'
        required
      /> */}
      {/* <AuthTextField label='Email' name='email' value={formData.email} onChange={handleChange} /> */}
      {/* <TextField
        label='Password'
        type='password'
        variant='outlined'
        name='password'
        value={formData.password}
        onChange={handleChange}
        fullWidth
        margin='normal'
        required
      /> */}
        <Box sx={{ width: '100%', maxWidth: 320, mt: 1.5 }}>
          <AuthTextField label='Password' name='password' value={formData.password} onChange={handleChange} />
        </Box>
        <Box sx={{ width: '100%', maxWidth: 320, mt: 1.5 }}>
          <AuthTextField label='Repeat Password' name='repeatPassword' value={formData.repeatPassword} onChange={handleChange} />
        </Box>
      {/* <TextField
        label='Repeat Password'
        type='password'
        variant='outlined'
        name='repeatPassword'
        value={formData.repeatPassword}
        onChange={handleChange}
        fullWidth
        margin='normal'
        required
      /> */}
        <Button
          sx={{
            width: '100%',
            maxWidth: 320,
            mt: 2.5,
            borderRadius: '20px',
            backgroundColor: '#5FC56E',
            '&:hover': { opacity: 0.9 },
          }}
          type='submit'
          variant='contained'
          color='primary'
        >
          Register
        </Button>
      </form>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          variant='filled'
          sx={{
            backgroundColor: snackbar.severity === 'success' ? '#5FC56E' : undefined,
            '&.MuiAlert-filledError': { backgroundColor: '#d32f2f' },
          }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  )
}

export default Registration
